import _                                       from 'lodash'
import React                                   from 'react'
import { Modal, Alert, ButtonToolbar, Button } from 'react-bootstrap'

import { ContactFormLink      } from 'alto-react-client-auth/lib/routes'
import { IfContactFormEnabled } from 'alto-react-client-auth/lib/components'
import { MenuSummary          } from 'alto-react-canteen/lib/models'

export default class OrderSummaryModal extends React.Component
  render: ->
    <Modal show={true} onHide={@props.cancel} id='order-summary-modal'>
      <Modal.Header><Modal.Title>Potvrzení objednávky</Modal.Title></Modal.Header>

      <Modal.Body className="container-fluid scrollable">
        {@error()}
        {@summary()}
      </Modal.Body>

      <Modal.Footer>{@buttons()}</Modal.Footer>
    </Modal>

  error: ->
    if @props.error
      <Alert bsStyle='danger'>
        Došlo k chybě při ukládání změn. Zkuste opakovat později

        <IfContactFormEnabled>
          nebo <ContactFormLink>nás kontaktujte</ContactFormLink>
        </IfContactFormEnabled>

        .
      </Alert>

  summary: ->
    MenuSummary.for(@props.menu).canteenMenus().map (canteenMenu, index) ->
      <div key={index}>
        <h1>{canteenMenu.canteen.name}</h1>
        {canteenMenu.dailyMenus().map (dailyMenu, index) ->
          <div key={index}>
            <hr />
            <h2>{_.capitalize(dailyMenu.date.locale('cs').format('dddd, LL'))}</h2>
            {dailyMenu.groupMenus().map (groupMenu, index) ->
              <div key={index}>
                <h3>{groupMenu.group.displayName}</h3>
                {groupMenu.courseMenus().map (courseMenu, index) ->
                  <p key={index}>
                    {courseMenu.course.displayName + ' - ' if groupMenu.hasMoreThanOneCourse()}
                    {courseMenu.selectedMeal()?.name}
                  </p>
                }
              </div>
            }
          </div>
        }
      </div>

  buttons: ->
    <React.Fragment>
      <ButtonToolbar className='order-summary-button-toolbar top'>
        {@cancelButton()}
        {@saveButton()}
      </ButtonToolbar>

      <ButtonToolbar className='order-summary-button-toolbar bottom'>
        {@logOutButton()}
        {@saveAndLogOutButton()}
      </ButtonToolbar>
    </React.Fragment>

  cancelButton: ->
    <Button className='order-summary-button' bsStyle='warning' onClick={@props.cancel}>
      Zpět
    </Button>

  logOutButton: ->
    <Button className='order-summary-button' bsStyle='danger' onClick={@props.logOut}>
      Odhlásit bez uložení změn
    </Button>

  saveButton: ->
    <Button className='order-summary-button' bsStyle='primary'
            onClick={@props.save} disabled={@props.inProgress}>
      {if @props.inProgress then 'Ukládám' else 'Uložit'}
    </Button>

  saveAndLogOutButton: ->
    <Button className='order-summary-button' bsStyle='success'
            onClick={@props.saveAndLogOut} disabled={@props.inProgress}>
      {if @props.inProgress then 'Ukládám' else 'Uložit a odhlásit'}
    </Button>
